import styled, { css } from 'styled-components'

export const CustomThumbnail = styled.img`
  ${({ theme }) => css`
    width: ${theme.size.s2};
    aspect-ratio: 1;
    border-radius: ${theme.borderRadius.xs};
  `}
`
